import {
  HttpClient, HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { apiConfiguration } from '../../../../configurations/api-configuration';
import { AccessService } from '../../../application/services/AccessService';
import { HttpResponse } from '../../../application/types/HttpResponse';
import {
  SaveTeamData,
  Team,
  TeamDetails,
} from '../../types/Event';

@Injectable()
export class TeamApiService {
  private readonly teamsUrl = `${apiConfiguration.baseApiUrl}/teams`;

  public constructor(
    private http: HttpClient,
    private accessService: AccessService,
  ) { }

  public async getTeams(): Promise<HttpResponse<Team[]>> {
    return lastValueFrom(this.http.get<HttpResponse<Team[]>>(this.teamsUrl, { headers: this.getHeaders() }));
  }

  public async getTeam(teamId: string): Promise<HttpResponse<TeamDetails | null>> {
    return lastValueFrom(this.http.get<HttpResponse<TeamDetails | null>>(`${this.teamsUrl}/${teamId}`, { headers: this.getHeaders() }));
  }

  public async createTeam(data: SaveTeamData): Promise<HttpResponse<Team>> {
    return lastValueFrom(this.http.post<HttpResponse<Team>>(this.teamsUrl, data, { headers: this.getHeaders() }));
  }

  public async updateTeam(teamId: string, data: Partial<SaveTeamData>): Promise<HttpResponse<Team>> {
    return lastValueFrom(this.http.put<HttpResponse<Team>>(`${this.teamsUrl}/${teamId}`, data, { headers: this.getHeaders() }));
  }

  public async uploadTeamLogo(teamId: string, logo: File): Promise<HttpResponse<Team>> {
    const formData = new FormData();
    formData.append('logo', logo);

    return lastValueFrom(this.http.post<HttpResponse<Team>>(`${this.teamsUrl}/${teamId}/logo`, formData, { headers: this.getHeaders() }));
  }

  public async deleteTeam(teamId: string): Promise<HttpResponse<void>> {
    return lastValueFrom(this.http.delete<HttpResponse<void>>(`${this.teamsUrl}/${teamId}`, { headers: this.getHeaders() }));
  }

  private getHeaders(): HttpHeaders {
    const token = this.accessService.getToken();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
  }
}
